import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import DashboardTasks from "../pages/DashboardTasks";
import GeneralDetailTask from "../pages/DashboardTasks/Pages/GeneralDetailTask";

export const tasksRoutes = (
    <>
        <Route
            path={ROUTES.task_manager}
            element={<DashboardTasks />}
            key="task_manager"
        />
        {/* detail task */}
        <Route
            path="/tasks/:id_task/user/:id_user/detail"
            element={<GeneralDetailTask />}
            key="detail_task"
        />
    </>
);
